import { BackIcon } from 'assets/icons';
import { CustomButton, CustomTextArea } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import React, { FC, useState } from 'react';

interface EditEstimateDescriptionPanelProps {
  description: string;
  onBackClick: () => void;
  onSave: (description: string) => void;
  estimateId: string;
  teamId: number;
}

const EditEstimateDescriptionPanel: FC<EditEstimateDescriptionPanelProps> = ({ description, onBackClick, onSave }) => {
  const [estimateDescription, setEstimateDescription] = useState(description);

  const onSaveClick = () => {
    onSave(estimateDescription.trim());
  };

  return (
    <div className="h-full w-96">
      <div className="mb-1 flex items-center border-b border-secondaryBtn py-4">
        <BackIcon className="mx-4 cursor-pointer" id="estimate-details-panel-back-arrow" onClick={onBackClick} />
        <div className="text-17px font-semibold text-headingGray">Estimate description</div>
      </div>
      <div className="py-6 px-4">
        <CustomTextArea
          id="edit-estimate-description"
          name="edit-estimate-description"
          placeholder="Enter estimate description"
          className="h-[140px] max-h-[140px] rounded-md border border-borderGray bg-transparent font-semibold 
                    text-primaryText focus:outline-none"
          value={estimateDescription}
          onChange={setEstimateDescription}
          maxLength={1000}
          showRemainingChar={true}
        />
      </div>
      <div className="flex w-full flex-col gap-y-4 p-4 pt-0">
        <CustomButton
          id="edit-estimate-description-save-button"
          className="w-full"
          onClick={onSaveClick}
          type={ButtonType.PRIMARY}
          disabled={description.trim() === estimateDescription.trim()}>
          Save
        </CustomButton>
        <CustomButton
          id="edit-estimate-description-cancel-button"
          className="w-full"
          onClick={onBackClick}
          type={ButtonType.SECONDARY}>
          Cancel
        </CustomButton>
      </div>
    </div>
  );
};

export default EditEstimateDescriptionPanel;
